/*
 * Stratus — launch countdown (<st-countdown>), used by sections/st-password-main.liquid.
 *
 * data-launch is an ISO date and time with its UTC offset (2026-10-15T22:00:00-04:00). The element is rendered
 * hidden and shown once the date parses; each [data-countdown="days|hours|minutes|seconds"] gets two digits (days
 * grow past 99 if they must). It ticks every second and stops at zero.
 */
if (!customElements.get('st-countdown')) {
  class StCountdown extends HTMLElement {
    connectedCallback() {
      this.target = Date.parse(this.dataset.launch || '');
      if (Number.isNaN(this.target)) return;
      this.values = {};
      this.querySelectorAll('[data-countdown]').forEach((node) => {
        this.values[node.dataset.countdown] = node;
      });
      this.tick();
      this.hidden = false;
      this.timer = window.setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    tick() {
      let left = Math.max(0, Math.floor((this.target - Date.now()) / 1000));
      if (left === 0) window.clearInterval(this.timer);
      const parts = {days: Math.floor(left / 86400)};
      left %= 86400;
      parts.hours = Math.floor(left / 3600);
      left %= 3600;
      parts.minutes = Math.floor(left / 60);
      parts.seconds = left % 60;
      Object.entries(parts).forEach(([unit, value]) => {
        const node = this.values[unit];
        const text = String(value).padStart(2, '0');
        if (node && node.textContent !== text) node.textContent = text;
      });
    }
  }

  customElements.define('st-countdown', StCountdown);
}
